import React, { useEffect } from "react";
import './contact.scss';
import linkedin from './../../image/linkedin.svg';
import behance from './../../image/behance.svg';
import { Link } from "react-router-dom";

const Contact: React.FC = () => {
  

  return (
    <>
      <section className="contact container">
        <div className="wrapper">
          <h1>Let’s work together!</h1>
          <h2>Contact me in case of any questions <br></br>or opportunities🚀</h2>
          <a href="mailto:a.puliatti@hotmail.co.uk?subject=Hello&body=How are you?">a.puliatti@hotmail.co.uk</a>
          <div className="socialIcons">
            <Link to="https://www.linkedin.com/in/alexpuliatti/" className="navbar-link social">
              <img className="linkedin-icon" src={linkedin} alt="" />
            </Link>
            <Link to="https://www.behance.net/alexpuliatti2" className="navbar-link social">
              <img className="behance-icon" src={behance} alt="" />
            </Link>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default Contact;
